import React from 'react'
import { Text, Group, Stack } from '@mantine/core'
import i18n from 'live/services/i18n'
import { IconChartBarPopular } from '@tabler/icons-react'

const EmptyChartMetricsCard = (): React.ReactElement => {
    return (
        <Group align="center" position="apart" spacing="lg" grow>
            <Stack spacing={'sm'}>
                <Stack spacing="0">
                    <Text size="lg" ta="center" fw={600} lh="1.2" color="var(--mantine-text-default)">
                        {i18n('Stages completed')}
                    </Text>
                    <Text size="lg" ta="center" fw={600} lh="1.2" color="var(--mantine-text-default)">
                        {i18n('per day')}
                    </Text>
                </Stack>
                <Text size="xs" ta="center" tt="uppercase" fw={400} color="var(--mantine-text-subtle)">
                    {i18n('In the last 7 days')}
                </Text>
            </Stack>
            <Group position="center">
        {<IconChartBarPopular size="3.75rem" />}
            <Text size="xs" ta="center" >{i18n('Try searching again with a different term or change the applied filters.')}</Text>
            </Group>
        </Group>
    )
}

export default EmptyChartMetricsCard
